'use strict';

import Vue from 'vue';
import { logger } from '@/logging';


export const fetchOwnFeedbacks = async ({ dispatch }, userID) => {
	return await dispatch('find', { query: { author: userID }});
};

//=================================================================================================================

export const fetchByActionID = async ({ dispatch }, actionID) => {
	return await dispatch('find', { query: { action: actionID }});
};


//=============================================================================
//=========================== Edit Dialog =====================================
//=============================================================================


export const createFeedback = ({ commit }, actionID) => {
	const { Feedback } = Vue.$FeathersVuex;
	const copy = new Feedback({ action: actionID });

	commit('setEditCopy', copy);
	commit('showEditDialog');
};

//=================================================================================================================

export const editFeedback = ({ commit }, { item }) => {
	commit('setEditCopy', item.clone());
	commit('showEditDialog');
};

//=================================================================================================================

export const saveFeedback = async ({ commit }, { item }) => {
	try {
		// format date to YYYY-MM-DD
		item.date = new Date(item.date).toISOString().slice(0, 10);

		await item.save();

		commit('hideEditDialog');
		commit('clearEditCopy');
	}
	catch(err) {
		logger.get('feedbacks').error('Error when saving feedback', err);
		throw err;
	}
};

//=================================================================================================================

export const cancelFeedbackChanges = ({ commit }, { item }) => {
	commit('hideEditDialog');
	commit('clearEditCopy');
	item.id && item.reset();
};

//=================================================================================================================

export const deleteFeedback = async (context, { item }) => {
	try {
		return await item.remove();
	}
	catch(err) {
		logger.get('feedbacks').error('Error when deleting feedback', err);
		throw err;
	}
};
